import { render, staticRenderFns } from "./DraggbleWindow.vue?vue&type=template&id=560d0e3c&scoped=true&"
import script from "./DraggbleWindow.vue?vue&type=script&lang=js&"
export * from "./DraggbleWindow.vue?vue&type=script&lang=js&"
import style0 from "./DraggbleWindow.vue?vue&type=style&index=0&id=560d0e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d0e3c",
  null
  
)

export default component.exports